/**
 * View Tag Feature: CSS_SELECTOR
 * @module
 */

var locatorType = require('core/tags').enums.locatorType;

module.exports = function(PluginManager) {
  PluginManager.registerViewTagLocator(locatorType.CSS_SELECTOR, require('./css_selector'));
};
